module.exports = __webpack_public_path__ + "static/media/case-study-ailsa-bay.3fe9b0f4.jpg";